import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/logo.jpg'


const _hoisted_1 = {
  class: "home",
  style: {"margin-left":"20px","margin-right":"20px"}
}
const _hoisted_2 = { style: {"margin":"0 auto"} }
const _hoisted_3 = {
  key: 0,
  alt: "Vue logo",
  src: _imports_0,
  style: {"width":"100%"}
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div><div style=\"font-size:40px;color:#63acb5;\">欢迎来到科高匿名版</div><p> 这里是科高匿名版（nmbkg或者kgnmb），是几个科高老登一起建立的匿名版，由于一些匿名版传统因素，这里也可以叫科岛，访问这里的用户也可以称为岛民。<br> 科岛建立的初衷其实要追溯到某个科高老登在读书时候的想法，他一直想要有一个科高的学生们能自由交流校内事务的论坛，受到当时a岛匿名版的启发，决定自己也要开发一个属于科高的匿名版，因为某些拖延症，拖到了现在（2024）。<br> 当前的科岛也没有什么特别的注册流程，点击左上角的获取饼干将会自动获取到登陆的一个32位字符串的凭证，如果想要一直使用，建议自行保存，这将是你移动到其他设备上时唯一的凭证<br> 在科岛上没有什么身份，当然也尽量不要透露自己的身份，请遵循匿名原则，这里重要的是交流与信息。<br> 这里没有什么管理员，所有岛民拥有相同的权力（如果说直接通过修改数据库去权限的话，还是有几个管理员的）<br> 如果你对某个串持相反意见或者认为他影响到了科岛，那么可以点击右下角的赞成sage，当这个赞成到达一定量的时候，串将会被隐藏（帖子，由于帖子的组织方式是串在一起的，所以也可以称之为串，sage则是某些匿名版传统，可以称之为下去）。<br> 暂时还没有什么复杂规则，由于老登们之前的大部分匿名版经验来自于a岛（现x岛），在科岛的运行过程中也会逐渐衍生出各种规则，而每位岛民都拥有提出和制定规则的权力，在未来大家一起遵守！<br> 最后借用一下鲁迅先生的话：<br> “有一分热，发一分光，就令萤火一般，也可以在黑暗里发一点光，不必等候炬火。此后如竟没有炬火，我便是唯一的光。” </p></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.mobileStatus)
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _hoisted_4
  ]))
}